export default __webpack_public_path__ + "static/media/collisionWarning.88377b2d.png";